// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__21Eby","colMin":"styles_colMin__ksDu0","colCheckbox":"styles_colCheckbox__56M0Z"};